import FingerprintJS from "@fingerprintjs/fingerprintjs";

export function emailConfirmation() {
  return {
    async init() {
      try {
        const fp = await FingerprintJS.load({
          monitoring: false, // Disable monitoring for privacy
        });

        const result = await fp.get();
        const fingerprint = result.visitorId;

        const fingerprintField = document.getElementById("device_fingerprint");
        if (fingerprintField) {
          fingerprintField.value = fingerprint;
        }
      } catch (error) {
        console.warn("Failed to generate device fingerprint:", error);
      }
    },

    handlePaste(event) {
      const { form } = this.$refs;

      setTimeout(() => {
        if (event.target.value.length === 6) {
          const btn = form.querySelector("button[type=submit]");
          btn.disabled = true;
          btn.classList.add("btn-disabled");
          btn.classList.remove("btn-standout");
          form.submit();
        }
      }, 50);
    },
  };
}
